module.exports = __webpack_public_path__ + "static/img/album01_1.f769ec0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/welfare/album01_1.png
// module id = 8Hc7
// module chunks = 1